import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableRow, TableCell, Tooltip, IconButton, Checkbox, FormControlLabel } from '@mui/material';
import { TextField } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { Delete } from '@mui/icons-material';

const QuestionDetailListItemComponent = ({
  questionIndex,
  validation,
  item,
  questionDetailIndex,
  isReadOnly,
  onDetailPropertyChanged,
  onDeleteQuestionDetailRow
}) => {
  const { t } = useTranslation();

  return (
    <TableRow hover key={questionDetailIndex}>
      <TableCell>
        <TextField
          fullWidth
          value={item.questionDetailCode || ''}
          onChange={event => onDetailPropertyChanged('questionDetailCode', event, questionIndex, questionDetailIndex)}
          error={!isValid(validation.questionDetailCode)}
          helperText={getErrors(validation.questionDetailCode)}
          disabled={isReadOnly}
        />
      </TableCell>
      <TableCell>
        <TextField
          fullWidth
          value={item.questionValue || ''}
          onChange={event => onDetailPropertyChanged('questionValue', event, questionIndex, questionDetailIndex)}
          error={!isValid(validation.questionValue)}
          helperText={getErrors(validation.questionValue)}
          disabled={isReadOnly}
        />
      </TableCell>
      <TableCell>
        <FormControlLabel
          control={
            <Checkbox
              checked={item.isDefault || false}
              onChange={event => onDetailPropertyChanged('isDefault', event.target.checked, questionIndex, questionDetailIndex)}
              disabled={isReadOnly}
            />
          }
          label={t('Questionnaire.Question.QuestionDetail.IsDefault')}
        />
      </TableCell>
      <TableCell>
        <TextField
          isNumeric
          value={item.questionScore}
          decimalScale={0}
          onChange={event => onDetailPropertyChanged('questionScore', event, questionIndex, questionDetailIndex)}
          disabled={isReadOnly}
        />
      </TableCell>
      <TableCell>
        <Tooltip title={t('Tooltips.Questionnaire.DeleteQuestionDetail')}>
          <IconButton color='primary' onClick={onDeleteQuestionDetailRow(questionIndex, questionDetailIndex)} disabled={isReadOnly}>
            <Delete />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

QuestionDetailListItemComponent.propTypes = {
  item: PropTypes.object.isRequired,
  questionIndex: PropTypes.number,
  questionDetailIndex: PropTypes.number,
  validation: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool,
  onDetailPropertyChanged: PropTypes.func.isRequired,
  onDeleteQuestionDetailRow: PropTypes.func.isRequired
};

export default QuestionDetailListItemComponent;
